import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-delete-virtual-cash-dialog',
  templateUrl: './delete-virtual-cash-dialog.component.html',
  styleUrls: ['./delete-virtual-cash-dialog.component.scss']
})
export class DeleteVirtualCashDialogComponent {
  @Input() deleteId!: number
  @Output() deleteEvent: EventEmitter<number> = new EventEmitter<number>()
  protected readonly close = close;

  constructor(
    private modalService: ModalService
  ) {
  }


  closeModal() {
    this.modalService.isModalOpen$.next(false)
  }

  deleteCash() {
    this.deleteEvent.emit(this.deleteId)
  }
}
